import React, { ReactNode } from 'react';
import { Hosts } from '../../../../../constants/hostName';

const brand = (siteNumber: Hosts) => {
  switch (siteNumber) {
    case Hosts.BREWBOUND:
      return 'Brewbound';
    case Hosts.NOSH:
      return 'Nosh';
    default:
      return 'BevNET';
  }
};

export const info: { title: string, description: ((siteNumber: Hosts) => string) | ((siteNumber: Hosts) => ReactNode) }[] = [
  {
    title: 'Standard listing - 60 day',
    description: (siteNumber) => `Appears on the ${brand(siteNumber)} Jobs page and in the weekly ${brand(siteNumber)} Jobs Email Newsletter. Perfect for single, time-sensitive openings.`
  },
  {
    title: 'Featured listing - 60 day',
    description: (siteNumber) => `Includes all Standard features plus top placement on the Jobs page, visibility in the featured jobs box on every news article, and premium placement in the weekly ${brand(siteNumber)} Jobs Email Newsletter.`
  }
];
